<template>
  <a
    :key="model.uid"
    :href="model.url"
    class="recipe-card group bg-white"
    @click="onRecipeClick"
  >
    <Picture
      v-bind="model.image"
      class="block relative h-0 pb-9/16 overflow-hidden rounded"
      img-class="absolute top-0 left-0 w-full h-full object-cover transform transition-transform duration-300 group-hover:scale-105"
      :mobile="[160, 90]"
      :tablet="[310, 175]"
      width="310"
      height="175"
    />

    <div class="p-2 md:p-4">
      <div class="text-2xs md:text-xs uppercase md:normal-case">{{ model.cookingTimeText }}</div>
      <div class="font-semibold text-sm lg:text-lg">{{ model.title }}</div>
    </div>
  </a>
</template>

<script>
import tracking from '@/helpers/tracking'
import Picture from '@/components/Picture.vue'

export default {
  components: {
    Picture
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    trackingObj: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    onRecipeClick() {
      if (this.trackingObj) {
        const {
          currentFilters,
          placement
        } = this.trackingObj

        const { title: recipeName } = this.model

        tracking.recipeClick({
          recipeName,
          currentFilters,
          placement
        })
      }
    }
  }
}
</script>
